module.exports = __webpack_public_path__ + "img/yyz3.55439520.png";